import { render } from "./ValueListForm.vue?vue&type=template&id=2ba183e2&ts=true"
import script from "./ValueListForm.vue?vue&type=script&lang=ts"
export * from "./ValueListForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__